export default __webpack_public_path__ + "static/media/logoRestoBlack.aa4f3186.png";